exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wr-readonly-container {\n  margin-top: 15px;\n  margin-bottom: 15px;\n}\n\n.wr-readonly-title {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  margin-bottom: 10px;\n}\n\n.wr-readonly-title h5 {\n  font-weight: 600;\n  color: #37474f;\n  white-space: nowrap;\n  margin-right: 15px;\n}\n\n.wr-line {\n  -ms-flex-positive: 1;\n      flex-grow: 1;\n  height: 1px;\n  background-color: #e4eaec;\n}\n\n.wr-info-row {\n  display: -ms-flexbox;\n  display: flex;\n  margin-bottom: 8px;\n  -ms-flex-align: start;\n      align-items: flex-start;\n}\n\n.wr-label {\n  color: #76838f;\n  width: 220px;\n  min-width: 220px;\n  padding-right: 10px;\n}\n\n.wr-value {\n  color: #37474f;\n  font-weight: 500;\n  -ms-flex: 1;\n      flex: 1;\n}\n\n.text-success {\n  color: #4caf50 !important;\n}\n\n.text-danger {\n  color: #f44336 !important;\n}\n\n.font-weight-bold {\n  font-weight: bold !important;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/common/components/warranty-reminder/warranty-reminder-readonly/warranty-reminder-readonly.component.css
// module id = ../../../../../src/app/common/components/warranty-reminder/warranty-reminder-readonly/warranty-reminder-readonly.component.css
// module chunks = 3